import type { Metier } from "models";

export function sortMetier(metiers: Array<Metier>): Array<Metier> {
  return metiers.toSorted((mA, mB) => mA.libelle.localeCompare(mB.libelle));
}
